<template>
  <div>
   <div v-if="data?.length > 0">
      <w-table ref="wMyTable" :columns="columns" :table-data="data" :isPagination="true" :page="page"
        @pageChange="handlePagePagination" :openTableHeadNote="false">
        <div slot="projectClassification" slot-scope="{text,record}">
          <div class="status-tag-container">
            <el-tag type="success">{{TypeOption.find(item => item.label === text).name}}</el-tag>
          </div>
        </div>
        <div slot="sizeOfSampleData" class="status-tag-container" slot-scope="{text,record,index}">
          <!-- 左侧组件 -->
          <div>
            <ex-fold-table v-if="record.projectSampleDataList['old']?.[0]?.['sizeOfSampleData']"
              :scope="{ time: time.filter(item => Object.keys(record.projectSampleDataList['old']?.[0]?.['sizeOfSampleData']).includes(item.time)), record: record.projectSampleDataList['old'], dataIndex: 'sizeOfSampleData', index, dataAmountUnit: record['dataAmountUnit'] }"></ex-fold-table>
          </div>
          <!-- 箭头 -->
          <span style="color:#dc3131;margin:0 auto"><i class="el-icon-right"></i></span>
          <!-- 右侧组件 -->
          <div>
            <ex-fold-table v-if="record.projectSampleDataList['new']?.[0]?.['sizeOfSampleData']"
              :style="{ color: record.projectSampleDataList['change'] ? '#dc3131' : '' }"
              :scope="{ time: time.filter(item => Object.keys(record.projectSampleDataList['new']?.[0]?.['sizeOfSampleData']).includes(item.time)), record: record.projectSampleDataList['new'], dataIndex: 'sizeOfSampleData', index, dataAmountUnit: record['dataAmountUnit'] }"></ex-fold-table>
          </div>
        </div>
        <div slot="projectAmount" slot-scope="{text,record,index}">
          <div class="status-tag-container">
            <div class="status-tag-container">
              <div v-if="record.experimentalProcessItems['old'] && record.experimentalProcessItems['old'].length > 0">
                <div v-for="(data, index) in record.experimentalProcessItems['old']">
                  <span>{{ data.experimentName + ':' + data.experimentAmount }}</span><br>
                </div>
              </div>
              <div v-else>
                <div v-if="text && text['old']">
                  {{ text['old'] }}
                </div>
              </div>
            </div>
            <!-- 箭头 -->
            <span style="color:#dc3131;margin:0 auto"><i class="el-icon-right"></i></span>
            <!-- 右侧组件 -->
            <div class="status-tag-container">
              <div v-if="record.experimentalProcessItems['new'] && record.experimentalProcessItems['new'].length > 0">
                <div v-for="(data, index) in record.experimentalProcessItems['new']">
                  <span :style="{ color: record.experimentalProcessItems['change'] ? '#dc3131' : '' }">{{
                    data.experimentName +
                    ':' + data.experimentAmount
                    }}</span><br>
                </div>
              </div>
              <div v-else>
                <div v-if="text && text['new']" :style="{ color: text['change'] ? '#dc3131' : '' }">
                  {{ text['new'] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="numberOfSamples" slot-scope="{text,record,index}">
          <div class="status-tag-container">
            <div v-if="record.projectSampleDataList['old'].length > 0">
              <div v-if="record.experimentalProcessItems['old'] && record.experimentalProcessItems['old'].length > 0">
                <div v-for="(data, index) in record.experimentalProcessItems['old']">
                  <span>{{ data.experimentName + ':' + data.numberOfExperiment }}</span><br>
                </div>
              </div>
              <div v-else>
                <span
                  v-for="(data, index) in record.projectSampleDataList['old'] ? record.projectSampleDataList['old'] : []">{{
                    (index !== 0 ? '/' : '') + data.numberOfSamples }}</span>
              </div>
            </div>
            <!-- 箭头 -->
            <span style="color:#dc3131;margin:0 auto"><i class="el-icon-right"></i></span>
            <!-- 右侧组件 -->
            <div v-if="record.projectSampleDataList['new'].length > 0">
              <div v-if="record.experimentalProcessItems['new'] && record.experimentalProcessItems['new'].length > 0">
                <div v-for="(data, index) in record.experimentalProcessItems['new']">
                  <span :style="{ color: record.experimentalProcessItems['change'] ? '#dc3131' : '' }">{{
                    data.experimentName + ':' + data.numberOfExperiment }}</span><br>
                </div>
              </div>
              <div v-else>
                <span v-for="(data, index) in record.projectSampleDataList['new'] ? record.projectSampleDataList['new'] : []"
                  :style="{ color: record.projectSampleDataList['change'] ? '#dc3131' : '' }">{{ (index !== 0 ? '/' : '') +
                    data['numberOfSamples'] }}</span>
              </div>
            </div>

          </div>
        </div>
        <div slot="collectingFlag" slot-scope="{text,record,index}">
          <div v-if="record.projectMainTypeId" class="status-tag-container">
            <el-tag type="success" v-if="text">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </div>
          <div v-else class="status-tag-container">
            <el-tag type="info">NA</el-tag>
          </div>
        </div>
        <div slot="status" slot-scope="{record,index}">
          <div class="status-tag-container">
            <el-tag type="warning" v-if="record.status === 'change'">变更</el-tag>
            <el-tag type="success" v-else-if="record.status === 'add'">新增</el-tag>
            <el-tag type="danger" v-else-if="record.status === 'delete'">删除</el-tag>
          </div>
        </div>
        <div slot="qualityFlag" slot-scope="{text,record,index}">
          <div v-if="record.projectMainTypeId" class="status-tag-container">
            <el-tag type="success" v-if="text">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </div>
          <div v-else class="status-tag-container">
            <el-tag type="info">NA</el-tag>
          </div>
        </div>
        <div slot="sampleNum" slot-scope="{text,record,index}">
          <div v-if="text" class="status-tag-container">{{ text }}</div>
          <div v-else class="status-tag-container">{{ 'NA' }}</div>
        </div>
        <div slot="sequencingPlatform" slot-scope="{text,record,index}">
          <div class="status-tag-container">
            <div>
              <div v-if="text && text['old'] && Object.values(text['old']).filter(item => item).length > 0"
                class="status-tag-container" style="flex-direction: column; align-items: flex-start;">
                <span v-if="text['old']?.sequencingPlatform">{{ '二代：' + text['old'].sequencingPlatform }}</span>
                <span v-if="text['old']?.thirdSequencingPlatform">{{ '三代：' + text['old'].thirdSequencingPlatform
                  }}</span>
              </div>
              <div v-else class="status-tag-container">{{ 'NA' }}</div>
            </div>
            <!-- 箭头 -->
            <span style="color:#dc3131;margin:0 auto"><i class="el-icon-right"></i></span>
            <!-- 右侧组件 -->
            <div>
              <div v-if="text && text['new'] && Object.values(text['new']).filter(item => item).length > 0"
                class="status-tag-container"
                :style="{ color: text['change'] ? '#dc3131' : '', 'flex-direction': 'column', 'align-items': 'flex-start' }">
                <span v-if="text['new']?.sequencingPlatform">{{ '二代：' + text['new'].sequencingPlatform }}</span>
                <span v-if="text['new']?.thirdSequencingPlatform">{{ '三代：' + text['new'].thirdSequencingPlatform
                  }}</span>
              </div>
              <div v-else class="status-tag-container" :style="{ color: text['change'] ? '#dc3131' : '' }">{{ 'NA' }}
              </div>
            </div>
          </div>
        </div>
        <div slot="projectStatus" slot-scope="{text,record,index}">
          <div v-if="text === 'NORMAL'" class="status-tag-container"><el-tag type="success">正常</el-tag></div>
          <div v-else-if="text === 'TERMINATION'" class="status-tag-container"><el-tag type="danger">终止</el-tag></div>
          <div v-else class="status-tag-container"><el-tag type="info">NA</el-tag></div>
        </div>
        <div slot="analyzeRequirements" slot-scope="{text,record,index}">
          <div class="status-tag-container">
            <div v-if="text && text['old']">
              {{ text['old'] }}
            </div>
            <!-- 箭头 -->
            <span style="color:#dc3131;margin:0 auto"><i class="el-icon-right"></i></span>
            <!-- 右侧组件 -->
            <div v-if="text && text['new']" :style="{ color: text['change'] ? '#dc3131' : '' }">
              {{ text['new'] }}
            </div>
          </div>
        </div>
      </w-table>
    </div>
    <div v-if="data?.length === 0"
      style="width: 100%;padding:20px;text-align:center;color:#909399;">
      当前暂无项目变更信息。
    </div>
  </div>
</template>

<script>

import ExFoldTable from "@/components/ExFoldTable.vue";
import {getProjectList, getProjectStatus} from "@/api/dilivery/project";
import _ from "lodash";
import { isEqual } from "@/store/date";
import {projectChange} from "@/utils/data/tableCol/project/projectChange";

export default {
  name: "ProjectChangeData",
  components: {ExFoldTable},
  props: {
    title: {
      default: '项目'
    },
    showDialog: {
      default: true
    },
    oldData:{
      default:()=>([])
    },
    newData:{
      default:()=>([])
    },
    id: {
      default: ''
    },
    type:{
      default:''
    }
  },
  data(){
    return{
      data:[],
      table:[],
      time:[
        {name:'二代',time:'NGS'},
        {name:'三代',time:'PACBIO'},
        {name:'HIC',time:'HIC'},
        {name:'ONT',time:'ONT'}
      ],
      TypeOption: [
        {label: 'NGS', name: '二代测序'},
        {label: 'AMPLICON', name: '扩增子测序'},
        {label: 'TGG', name: '三代测序'},
        {label: 'METAPRO', name: '蛋白代谢组测序'},
        {label: '硬盘购买', name: '硬盘购买'},
        { label: 'IGUT', name: 'IGUT' },
        {label: 'PCR', name: '其他'}
      ],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      tableDataCopy:[]
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(projectChange([] || [])))
    }
  },
  mounted() {
    this.getProjectData()
  },
  methods: {
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getData() {
      this.page.total = this.table.length
      // 计算当前页的起始索引
      const startIndex = (this.page.currentNum - 1) * this.page.pageSize;
      // 返回当前页的数据
      this.data = this.table.slice(startIndex, startIndex + this.page.pageSize);
    },
    mergeArraysById(arr1, arr2) {
      const mergedMap = new Map();
      // 将数组1和数组2合并到Map中
      [...arr1, ...arr2].forEach(item => {
        if (mergedMap.has(Number(item.projectMainTypeId))) {
          // 如果已存在相同id的对象，合并键值
          const existingItem = mergedMap.get(Number(item.projectMainTypeId));
          mergedMap.set(Number(item.projectMainTypeId), { ...existingItem, ...item });
        } else {
          // 如果不存在，直接添加到Map中
          mergedMap.set(Number(item.projectMainTypeId), item);
        }
      });
      // 将Map转换为数组
      return Array.from(mergedMap.values());
    },
    async getProjectData() {
      try {
        const arr1 = [...this.oldData]
        const arr2 = [...this.newData]
        const map = new Map(arr1.map(item => [item.projectType, { ...item }]));
        arr2.forEach(item => {
          if (map.has(item.projectType)) {
            const existingItem = map.get(item.projectType);
            
          const sequencingPlatform = !isEqual({ sequencingPlatform: existingItem.sequencingPlatform, thirdSequencingPlatform: existingItem.thirdSequencingPlatform }, { sequencingPlatform: item.sequencingPlatform, thirdSequencingPlatform: item.thirdSequencingPlatform })
          const projectAmount = !isEqual(existingItem.projectAmount, item.projectAmount)
            const projectSampleDataList = !isEqual(existingItem.projectSampleDataList ? existingItem.projectSampleDataList : [], item.projectSampleDataList ? item.projectSampleDataList : [])
            const analyzeRequirements = !isEqual(existingItem.analyzeRequirements, item.analyzeRequirements)
            const experimentalProcessItems = !isEqual(existingItem.experimentalProcessItems, item.experimentalProcessItems)
            if (this.type === 'audit') {
              if (sequencingPlatform || projectAmount || projectSampleDataList || analyzeRequirements || experimentalProcessItems) {
                map.set(item.projectType, {
                  projectType: item.projectType,
                  status: 'change',
                  projectStatus: item.projectStatus,
                  sequencingPlatform: { old: { sequencingPlatform: existingItem.sequencingPlatform, thirdSequencingPlatform: existingItem.thirdSequencingPlatform }, new: { sequencingPlatform: item.sequencingPlatform, thirdSequencingPlatform: item.thirdSequencingPlatform }, change: sequencingPlatform },
                  projectMainTypeId: existingItem.projectMainTypeId ? existingItem.projectMainTypeId : item.projectMainTypeId,
                  projectAmount: { old: existingItem.projectAmount, new: item.projectAmount, change: projectAmount },
                  projectSampleDataList: {
                    old: existingItem.projectSampleDataList ? existingItem.projectSampleDataList : [],
                    new: item.projectSampleDataList ? item.projectSampleDataList : [],
                    change: projectSampleDataList
                  },
                  projectClassification: existingItem.projectClassification ? existingItem.projectClassification : item.projectClassification,
                  analyzeRequirements: { old: existingItem.analyzeRequirements, new: item.analyzeRequirements, change: analyzeRequirements },
                  experimentalProcessItems: { old: existingItem.experimentalProcessItems, new: item.experimentalProcessItems, change: experimentalProcessItems },
                });
              } else {
                map.delete(item.projectType)
              }
            } else {
              map.set(item.projectType, {
                projectType: item.projectType,
                status: 'change',
                projectStatus: item.projectStatus,
                sequencingPlatform: { old: { sequencingPlatform: existingItem.sequencingPlatform, thirdSequencingPlatform: existingItem.thirdSequencingPlatform }, new: { sequencingPlatform: item.sequencingPlatform, thirdSequencingPlatform: item.thirdSequencingPlatform }, change: sequencingPlatform },
                projectMainTypeId: existingItem.projectMainTypeId ? existingItem.projectMainTypeId : item.projectMainTypeId,
                projectAmount: { old: existingItem.projectAmount, new: item.projectAmount, change: projectAmount },
                projectSampleDataList: {
                  old: existingItem.projectSampleDataList ? existingItem.projectSampleDataList : [],
                  new: item.projectSampleDataList ? item.projectSampleDataList : [],
                  change: projectSampleDataList
                },
                projectClassification: existingItem.projectClassification ? existingItem.projectClassification : item.projectClassification,
                analyzeRequirements: { old: existingItem.analyzeRequirements, new: item.analyzeRequirements, change: analyzeRequirements },
                experimentalProcessItems: { old: existingItem.experimentalProcessItems, new: item.experimentalProcessItems, change: experimentalProcessItems },
              });
            }
          } else {
            map.set(item.projectType, {
              projectType: item.projectType,
              status:'add',
              projectStatus: item.projectStatus,
              sequencingPlatform:{ old: { sequencingPlatform: '', thirdSequencingPlatform: '' }, new: { sequencingPlatform: item.sequencingPlatform, thirdSequencingPlatform: item.thirdSequencingPlatform }, change:true },

              projectMainTypeId: item.projectMainTypeId,
              projectAmount: { old: '', new: item.projectAmount, change: true },
              projectSampleDataList: { old: [], new: item.projectSampleDataList ? item.projectSampleDataList : [], change: true },
              projectClassification: item.projectClassification,
              analyzeRequirements: { old: '', new: item.analyzeRequirements, change: true },
              experimentalProcessItems: { old: [], new: item.experimentalProcessItems, change: true },
            });
          }
        });
        arr1.forEach(item => {
          if (!arr2.map(itemA => itemA.projectType).includes(item.projectType)) {
            map.set(item.projectType, {
              projectType: item.projectType,
              status:'delete',
              projectStatus: item.projectStatus,
              sequencingPlatform:{ old: { sequencingPlatform: item.sequencingPlatform?item.sequencingPlatform:'', thirdSequencingPlatform: item.thirdSequencingPlatform?item.thirdSequencingPlatform:'' }, new: { sequencingPlatform: '', thirdSequencingPlatform: '' } },

              projectMainTypeId:item.projectMainTypeId,
              projectAmount: { old: item.projectAmount?item.projectAmount:'', new: '' },
              projectSampleDataList: { old: item.projectSampleDataList?item.projectSampleDataList: [], new: [] },
              projectClassification: item.projectClassification,
              analyzeRequirements: { old: item.analyzeRequirements?item.analyzeRequirements:'', new: '' },
              experimentalProcessItems: { old: item.experimentalProcessItems ? item.experimentalProcessItems:[], new: [] },
            });
          }
        });
        this.tableDataCopy = Array.from(map.values())
        if (this.id) {
          const response = await getProjectStatus(this.id)
          if(response.code === 200) {
            this.tableDataCopy = this.mergeArraysById(this.tableDataCopy.filter(item => item.projectMainTypeId), response.data.filter(item => item.projectMainTypeId && this.tableDataCopy.map(item => Number(item.projectMainTypeId)).includes(Number(item.projectMainTypeId))))
            this.tableDataCopy = _.unionBy(this.tableDataCopy, Array.from(map.values()), 'projectType')
          }
        }
        let data = {
          "query#id.IN":this.tableDataCopy.filter(item => item.projectMainTypeId).map(item => item.projectMainTypeId).join(',')
        }
        const response = await getProjectList(data)
        if(response.code === 200){
          this.table = this.tableDataCopy.map(item => {
            const project = response.data.find(it => Number(it.id) === Number(item.projectMainTypeId))
            return {
              ...item,
              projectClassification:project?project.model:item.projectClassification,
              projectType:project?project.name:item.projectType,
              dataAmountUnit: (project?.attribute?.dataAmountUnit) ? project.attribute.dataAmountUnit : ''
            }
          })
          this.getData()
        }
      }catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
</style>
